import React from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

type CheckboxStyledProps = {
  isChecked?: boolean;
  defaultChecked?: boolean;
  onChange: (isChecked: boolean) => void;
  testId?: string;
  slotProps?: CheckboxProps['slotProps'];
};

export const CheckboxStyled: React.FC<CheckboxStyledProps> = ({
  isChecked,
  defaultChecked,
  onChange,
  testId,
  ...otherProps
}) => {
  const checkboxIcon = (
    <CheckBoxOutlineBlankIcon
      fontSize="small"
      sx={{ color: (theme) => theme.palette.text.secondary }}
    />
  );

  const checkboxCheckedIcon = (
    <CheckBoxIcon fontSize="small" sx={{ color: (theme) => theme.palette.text.secondary }} />
  );

  return (
    <Checkbox
      {...otherProps}
      sx={{
        '& .MuiTouchRipple-root': {
          opacity: '0',
        },
      }}
      defaultChecked={defaultChecked}
      icon={checkboxIcon}
      checkedIcon={checkboxCheckedIcon}
      checked={isChecked}
      onChange={(e) => onChange(e.target.checked)}
      data-testid={testId || 'checkbox'}
    />
  );
};
